/**
 * Set cookie
 *
 * @param {string} name
 * @param {any} value
 * @param {number} days
 * @param {boolean} encode
 */
export function setCookie(name,value,days, encode = false) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }

    if (encode) {
        value = btoa(value);
    }

    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax;";
}

/**
 * Get cookie value by name
 *
 * @param {string} name
 * @param {boolean} isEncoded
 * @returns {string|null}
 */
export function getCookie(name, isEncoded = false) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++) {
        let c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) {
            let val = c.substring(nameEQ.length,c.length);
            return isEncoded ? atob(val) : val;
        }
    }
    return null;
}

/**
 * Erase cookie by name
 *
 * @param {string} name
 */
export function eraseCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
